export interface Cr7State {
    showForceCasePopup: boolean;
    nioshTableLoading: boolean;
    isWaitingForRecalc?: boolean;
}

export const initialState: Cr7State = {
    showForceCasePopup: false,
    nioshTableLoading: false,
    isWaitingForRecalc: false
};

export const featureKey = 'cr7Module';
